import React, { Component } from "react"
import PropTypes from "prop-types"
import ItemNameCountShape from "../../state/shapes/ItemNameCountShape"
import Widget from "../layout/widget/Widget"
import PieChart from "../charts/generic/PieChart"
import { CHARTS } from "../../constants"

class RiskOfLeaving extends Component {
  setTrafficLightColours = () => {
    return [
      CHARTS.trafficLightColours.green,
      CHARTS.trafficLightColours.amber,
      CHARTS.trafficLightColours.red
    ]
  }

  render() {
    const { exportEndpoint, appliedFilters, data, subtitleKey, sampleSize } = this.props
    const titleKey = "Widgets.RiskOfLeaving.Title"

    return (
      <Widget
        columns={1}
        titleKey={titleKey}
        helpKey="Widgets.RiskOfLeaving.Help"
        exportEndpoint={exportEndpoint}
        appliedFilters={appliedFilters}
        subtitleKey={subtitleKey}
        sampleSize={sampleSize}
      >
        {/* <b>
          {sampleSize.percentage} {sampleSize.sample} {sampleSize.total}
        </b> */}
        <PieChart
          data={data}
          singularTooltipDescriptorKey="Common.Person" 
          pluralTooltipDescriptorKey="Common.People"
          overrideColours
          colours={this.setTrafficLightColours()}
          titleKey={titleKey}
          subtitleKey={subtitleKey}
        />
      </Widget>
    )
  }
}

RiskOfLeaving.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameCountShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default RiskOfLeaving



// WEBPACK FOOTER //
// ./src/components/widgets/RiskOfLeaving.jsx